<div class="template-selector-container">
  <!-- Header -->
  <div class="selector-header">
    <h2>Select Design Template</h2>
    <button mat-icon-button (click)="cancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Filters and Search -->
  <div class="selector-filters">
    <div class="search-bar">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search templates</mat-label>
        <input
          matInput
          [(ngModel)]="searchQuery"
          (input)="applySearch()"
          placeholder="Search by name, category...">
        <mat-icon matPrefix>search</mat-icon>
        <button
          mat-icon-button
          matSuffix
          *ngIf="searchQuery"
          (click)="clearSearch()">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>

      <button
        mat-icon-button
        (click)="toggleViewMode()"
        class="view-toggle"
        [matTooltip]="viewMode === 'grid' ? 'List View' : 'Grid View'">
        <mat-icon>{{ viewMode === 'grid' ? 'view_list' : 'view_module' }}</mat-icon>
      </button>
    </div>

    <!-- Category Filter -->
    <div class="category-filter" *ngIf="categories.length > 0">
      <mat-chip-list>
        <mat-chip
          [selected]="!selectedCategory"
          (click)="clearCategoryFilter()">
          All
        </mat-chip>
        <mat-chip
          *ngFor="let category of categories"
          [selected]="selectedCategory === category"
          (click)="filterByCategory(category)">
          {{ category }}
        </mat-chip>
      </mat-chip-list>
    </div>
  </div>

  <!-- Templates Grid/List -->
  <div class="selector-content" [class.loading]="isLoading">
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner></mat-spinner>
      <p>Loading templates...</p>
    </div>

    <!-- No Results -->
    <div *ngIf="!isLoading && filteredTemplates.length === 0" class="no-results">
      <mat-icon>search_off</mat-icon>
      <p>No templates found</p>
      <button mat-button color="primary" (click)="clearSearch(); clearCategoryFilter()">
        Clear Filters
      </button>
    </div>

    <!-- Grid View -->
    <div *ngIf="!isLoading && viewMode === 'grid' && filteredTemplates.length > 0" class="templates-grid">
      <div
        *ngFor="let template of filteredTemplates"
        class="template-card"
        [class.selected]="selectedTemplate?.templateId === template.templateId"
        (click)="selectTemplate(template)">
        <div class="template-thumbnail">
          <img [src]="template.thumbnailUrl" [alt]="template.name" *ngIf="template.thumbnailUrl">
          <div class="template-placeholder" *ngIf="!template.thumbnailUrl">
            <mat-icon>image</mat-icon>
          </div>
          <div class="template-overlay" *ngIf="selectedTemplate?.templateId === template.templateId">
            <mat-icon>check_circle</mat-icon>
          </div>
        </div>
        <div class="template-info">
          <h3 class="template-name">{{ template.name }}</h3>
          <p class="template-category">{{ template.category }}</p>
          <p class="template-description" *ngIf="template.description">
            {{ template.description }}
          </p>
        </div>
      </div>
    </div>

    <!-- List View -->
    <div *ngIf="!isLoading && viewMode === 'list' && filteredTemplates.length > 0" class="templates-list">
      <mat-list>
        <mat-list-item
          *ngFor="let template of filteredTemplates"
          class="template-list-item"
          [class.selected]="selectedTemplate?.templateId === template.templateId"
          (click)="selectTemplate(template)">
          <img matListAvatar [src]="template.thumbnailUrl" [alt]="template.name" *ngIf="template.thumbnailUrl">
          <div matListAvatar class="template-placeholder-small" *ngIf="!template.thumbnailUrl">
            <mat-icon>image</mat-icon>
          </div>
          <h3 matLine>{{ template.name }}</h3>
          <p matLine>{{ template.category }}</p>
          <p matLine class="description" *ngIf="template.description">{{ template.description }}</p>
          <mat-icon *ngIf="selectedTemplate?.templateId === template.templateId">check_circle</mat-icon>
        </mat-list-item>
      </mat-list>
    </div>
  </div>

  <!-- Pagination -->
  <div class="selector-pagination" *ngIf="totalPages > 1">
    <button
      mat-icon-button
      (click)="previousPage()"
      [disabled]="currentPage === 1">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <div class="page-numbers">
      <button
        *ngFor="let page of getPageNumbers()"
        mat-button
        [class.active]="currentPage === page"
        (click)="goToPage(page)">
        {{ page }}
      </button>
    </div>

    <button
      mat-icon-button
      (click)="nextPage()"
      [disabled]="currentPage === totalPages">
      <mat-icon>chevron_right</mat-icon>
    </button>

    <span class="page-info">
      Page {{ currentPage }} of {{ totalPages }} ({{ totalCount }} templates)
    </span>
  </div>

  <!-- Footer Actions -->
  <div class="selector-footer">
    <button mat-button (click)="cancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirmSelection()"
      [disabled]="!selectedTemplate">
      <mat-icon>check</mat-icon>
      Select Template
    </button>
  </div>
</div>
